(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-bloqueo-escritorio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function esBot() {
      var ua = navigator.userAgent || '';
      var patrones = /bot|crawler|spider|crawling|facebookexternalhit|facebot|google|bingbot|yandex|duckduckbot|slurp|baiduspider|applebot|whatsapp|telegrambot|twitterbot|linkedinbot|pinterest|petalbot|ahrefsbot|semrushbot|lighthouse|pagespeed|gtmetrix|headlesschrome|chrome-lighthouse|preview|embedly|quora|outbrain/i;
      return patrones.test(ua);
    }

    function esEditor() {
      try {
        if (window.Shopify && window.Shopify.designMode) return true;
        if (window.top !== window.self) return true;
      } catch (e) {
        return true;
      }
      return false;
    }

    function evaluar(seccion) {
      var activo = seccion.getAttribute('data-pa-activo') === '1';
      if (!activo) {
        document.body.classList.remove('pa-bloqueo-activo');
        return;
      }
      var limite = parseInt(seccion.getAttribute('data-pa-ancho'), 10) || 1024;
      var ancho = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      var tactil = (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) || ('ontouchstart' in window);
      var esEscritorio = ancho > limite && !tactil;

      if (esEscritorio && !esBot() && !esEditor()) {
        document.body.classList.add('pa-bloqueo-activo');
      } else {
        document.body.classList.remove('pa-bloqueo-activo');
      }
    }

    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var lista = raiz.querySelectorAll('[data-pa-bloqueo]');
      for (var i = 0; i < lista.length; i++) {
        (function (seccion) {
          evaluar(seccion);
          window.addEventListener('resize', function () { evaluar(seccion); });
        })(lista[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }

    document.addEventListener('shopify:section:load', function (e) { arrancar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-antes-despues"] && !Shopify.designMode) return;
  try {
    
  function paAbdIniciar(raiz) {
    var bloques = (raiz || document).querySelectorAll('.pa-seccion-abd');
    Array.prototype.forEach.call(bloques, function (bloque) {
      if (bloque.getAttribute('data-pa-abd-listo') === '1') {
        return;
      }
      bloque.setAttribute('data-pa-abd-listo', '1');
      var pista = bloque.querySelector('.pa-abd-pista');
      var caja = bloque.querySelector('.pa-abd-puntos');
      if (!pista || !caja) {
        return;
      }
      var slides = pista.querySelectorAll('.pa-abd-slide');
      if (slides.length < 2) {
        return;
      }
      var puntos = [];
      var activo = 0;
      var reloj = null;
      function irA(indice) {
        var s = slides[indice];
        if (!s) {
          return;
        }
        var pr = pista.getBoundingClientRect();
        var sr = s.getBoundingClientRect();
        var pad = parseFloat(window.getComputedStyle(pista).paddingLeft) || 0;
        pista.scrollTo({ left: sr.left - pr.left + pista.scrollLeft - pad, behavior: 'smooth' });
      }
      function detener() {
        if (reloj) {
          window.clearInterval(reloj);
          reloj = null;
        }
      }
      Array.prototype.forEach.call(slides, function (slide, indice) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pa-abd-punto';
        b.setAttribute('aria-label', 'Ver testimonio ' + (indice + 1));
        b.addEventListener('click', function () {
          detener();
          irA(indice);
        });
        caja.appendChild(b);
        puntos.push(b);
      });
      function marcar() {
        var pr = pista.getBoundingClientRect();
        var centro = pr.width / 2;
        var mejor = 0;
        var menor = Infinity;
        Array.prototype.forEach.call(slides, function (slide, i) {
          var sr = slide.getBoundingClientRect();
          var d = Math.abs(sr.left - pr.left + sr.width / 2 - centro);
          if (d < menor) {
            menor = d;
            mejor = i;
          }
        });
        activo = mejor;
        puntos.forEach(function (p, j) {
          if (j === mejor) {
            p.classList.add('pa-abd-punto-on');
          } else {
            p.classList.remove('pa-abd-punto-on');
          }
        });
      }
      var pendiente = null;
      pista.addEventListener('scroll', function () {
        if (pendiente) {
          window.cancelAnimationFrame(pendiente);
        }
        pendiente = window.requestAnimationFrame(marcar);
      }, { passive: true });
      window.addEventListener('resize', marcar);
      marcar();
      var ant = bloque.querySelector('.pa-abd-nav-ant');
      var sig = bloque.querySelector('.pa-abd-nav-sig');
      if (ant) {
        ant.addEventListener('click', function () {
          detener();
          irA((activo - 1 + slides.length) % slides.length);
        });
      }
      if (sig) {
        sig.addEventListener('click', function () {
          detener();
          irA((activo + 1) % slides.length);
        });
      }
      pista.addEventListener('pointerdown', detener, { passive: true });
      pista.addEventListener('touchstart', detener, { passive: true });
      var lapso = parseInt(bloque.getAttribute('data-pa-abd-auto'), 10) || 0;
      if (lapso > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reloj = window.setInterval(function () {
          irA((activo + 1) % slides.length);
        }, lapso);
      }
    });
  }
  paAbdIniciar(document);
  document.addEventListener('shopify:section:load', function (e) {
    paAbdIniciar(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-anticopia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function esBot() {
      var ua = navigator.userAgent || '';
      var patrones = /bot|crawler|spider|crawling|facebookexternalhit|facebot|google|bingbot|yandex|duckduckbot|slurp|baiduspider|applebot|whatsapp|telegrambot|twitterbot|linkedinbot|pinterest|petalbot|ahrefsbot|semrushbot|lighthouse|pagespeed|gtmetrix|headlesschrome|chrome-lighthouse|preview|embedly|quora|outbrain|tiktok|bytespider|snapchat/i;
      return patrones.test(ua);
    }

    function esEditor() {
      try {
        if (window.Shopify && window.Shopify.designMode) return true;
        if (window.top !== window.self) return true;
      } catch (e) {
        return true;
      }
      return false;
    }

    function permitidoEnCampo(destino) {
      if (!destino) return false;
      var t = destino.tagName ? destino.tagName.toLowerCase() : '';
      if (t === 'input' || t === 'textarea' || t === 'select') return true;
      if (destino.isContentEditable) return true;
      if (destino.closest && destino.closest('input, textarea, select, [contenteditable="true"]')) return true;
      return false;
    }

    function activar(seccion) {
      if (seccion.dataset.paIniciado === '1') return;
      seccion.dataset.paIniciado = '1';

      if (seccion.getAttribute('data-pa-activo') !== '1') return;
      if (esBot() || esEditor()) return;

      var clicDerecho = seccion.getAttribute('data-pa-clic-derecho') === '1';
      var seleccion = seccion.getAttribute('data-pa-seleccion') === '1';
      var imagenes = seccion.getAttribute('data-pa-imagenes') === '1';
      var atajos = seccion.getAttribute('data-pa-atajos') === '1';

      if (seleccion) document.body.classList.add('pa-anticopia-sel');
      if (imagenes) document.body.classList.add('pa-anticopia-img');

      if (clicDerecho) {
        document.addEventListener('contextmenu', function (e) {
          if (permitidoEnCampo(e.target)) return;
          e.preventDefault();
        });
      }

      if (imagenes) {
        document.addEventListener('dragstart', function (e) {
          if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'img') {
            e.preventDefault();
          }
        });
      }

      if (seleccion) {
        document.addEventListener('copy', function (e) {
          if (permitidoEnCampo(e.target)) return;
          e.preventDefault();
        });
      }

      if (atajos) {
        document.addEventListener('keydown', function (e) {
          if (permitidoEnCampo(e.target)) return;
          var k = (e.key || '').toLowerCase();
          var ctrl = e.ctrlKey || e.metaKey;
          if (e.key === 'F12') { e.preventDefault(); return; }
          if (ctrl && ['c', 's', 'u', 'a', 'p'].indexOf(k) !== -1) { e.preventDefault(); return; }
          if (ctrl && e.shiftKey && ['i', 'j', 'c'].indexOf(k) !== -1) { e.preventDefault(); return; }
        });
      }
    }

    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var lista = raiz.querySelectorAll('[data-pa-anticopia]');
      for (var i = 0; i < lista.length; i++) activar(lista[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }

    document.addEventListener('shopify:section:load', function (e) { arrancar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-cinta-logos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarCinta(seccion) {
      if (seccion.dataset.paIniciado === 'true') return;
      var pista = seccion.querySelector('.pa-cl-pista');
      if (!pista) return;
      var items = Array.prototype.slice.call(pista.children);
      if (items.length === 0) return;
      seccion.dataset.paIniciado = 'true';

      var velocidad = parseFloat(seccion.getAttribute('data-velocidad')) || 0.5;
      var pausaHover = seccion.getAttribute('data-pausa-hover') === 'true';
      var pos = 0;
      var largoLoop = 0;
      var pausado = false;
      var animando = false;

      function medirYClonar() {
        largoLoop = 0;
        items.forEach(function (item) {
          largoLoop += item.offsetWidth + parseFloat(getComputedStyle(item).marginLeft) + parseFloat(getComputedStyle(item).marginRight);
        });
        var marco = seccion.querySelector('.pa-cl-marco');
        var minimo = marco ? marco.offsetWidth * 2 : window.innerWidth * 2;
        var anchoActual = largoLoop;
        while (anchoActual < minimo) {
          items.forEach(function (item) {
            pista.appendChild(item.cloneNode(true));
          });
          anchoActual += largoLoop;
        }
      }

      function correr() {
        if (!pausado) {
          pos -= velocidad;
          if (Math.abs(pos) >= largoLoop) pos = 0;
          pista.style.transform = 'translateX(' + pos + 'px)';
        }
        requestAnimationFrame(correr);
      }

      if (pausaHover) {
        seccion.addEventListener('mouseenter', function () {
          pausado = true;
        });
        seccion.addEventListener('mouseleave', function () {
          pausado = false;
        });
      }

      function arrancar() {
        if (animando) return;
        animando = true;
        medirYClonar();
        correr();
      }

      var imagenes = pista.querySelectorAll('img');
      if (imagenes.length === 0) {
        arrancar();
        return;
      }
      var listas = 0;
      Array.prototype.forEach.call(imagenes, function (img) {
        if (img.complete) {
          listas++;
          if (listas === imagenes.length) arrancar();
        } else {
          img.addEventListener('load', function () {
            listas++;
            if (listas === imagenes.length) arrancar();
          });
          img.addEventListener('error', function () {
            listas++;
            if (listas === imagenes.length) arrancar();
          });
        }
      });
    }

    function iniciarTodas() {
      document.querySelectorAll('.pa-seccion-cinta-logos').forEach(iniciarCinta);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('.pa-seccion-cinta-logos');
      if (seccion) {
        seccion.dataset.paIniciado = 'false';
        iniciarCinta(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-cinta-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var pistas = raiz.querySelectorAll('.pa-promo-pista');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      for (var i = 0; i < pistas.length; i++) {
        if (reduce) pistas[i].style.animation = 'none';
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }
    document.addEventListener('shopify:section:load', function (e) { arrancar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-cinta-sellos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarCinta(seccion) {
      if (seccion.dataset.paCsInit === 'true') return;
      var pista = seccion.querySelector('.pa-cs-pista');
      if (!pista) return;
      var items = Array.prototype.slice.call(pista.children);
      if (items.length === 0) return;
      seccion.dataset.paCsInit = 'true';

      var velocidad = parseFloat(seccion.getAttribute('data-velocidad')) || 0.5;
      var pausaHover = seccion.getAttribute('data-pausa-hover') === 'true';
      var derecha = seccion.getAttribute('data-direccion') === 'derecha';
      var pos = 0;
      var largoLoop = 0;
      var pausado = false;
      var animando = false;

      function medirYClonar() {
        largoLoop = 0;
        items.forEach(function (item) {
          var estilo = getComputedStyle(item);
          largoLoop += item.offsetWidth + parseFloat(estilo.marginLeft) + parseFloat(estilo.marginRight);
        });
        var marco = seccion.querySelector('.pa-cs-marco');
        var minimo = marco ? marco.offsetWidth * 2 : window.innerWidth * 2;
        var anchoActual = largoLoop;
        while (anchoActual < minimo) {
          items.forEach(function (item) {
            pista.appendChild(item.cloneNode(true));
          });
          anchoActual += largoLoop;
        }
        if (derecha) pos = -largoLoop;
      }

      function correr() {
        if (!pausado) {
          if (derecha) {
            pos += velocidad;
            if (pos >= 0) pos = -largoLoop;
          } else {
            pos -= velocidad;
            if (Math.abs(pos) >= largoLoop) pos = 0;
          }
          pista.style.transform = 'translateX(' + pos + 'px)';
        }
        requestAnimationFrame(correr);
      }

      if (pausaHover) {
        seccion.addEventListener('mouseenter', function () {
          pausado = true;
        });
        seccion.addEventListener('mouseleave', function () {
          pausado = false;
        });
      }

      function arrancar() {
        if (animando) return;
        animando = true;
        medirYClonar();
        correr();
      }

      var imagenes = pista.querySelectorAll('img');
      if (imagenes.length === 0) {
        arrancar();
        return;
      }
      var listas = 0;
      Array.prototype.forEach.call(imagenes, function (img) {
        if (img.complete) {
          listas++;
          if (listas === imagenes.length) arrancar();
        } else {
          img.addEventListener('load', function () {
            listas++;
            if (listas === imagenes.length) arrancar();
          });
          img.addEventListener('error', function () {
            listas++;
            if (listas === imagenes.length) arrancar();
          });
        }
      });
    }

    function iniciarTodas() {
      document.querySelectorAll('.pa-seccion-cinta-sellos').forEach(iniciarCinta);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('.pa-seccion-cinta-sellos');
      if (seccion) {
        seccion.dataset.paCsInit = 'false';
        iniciarCinta(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function dosDigitos(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function iniciar(reloj) {
      if (reloj.dataset.paIniciado === '1') return;
      reloj.dataset.paIniciado = '1';

      var elDias = reloj.querySelector('[data-pa-dias]');
      var elHoras = reloj.querySelector('[data-pa-horas]');
      var elMin = reloj.querySelector('[data-pa-min]');
      var elSeg = reloj.querySelector('[data-pa-seg]');

      var modo = reloj.getAttribute('data-pa-modo') || 'diario';
      var fechaTexto = reloj.getAttribute('data-pa-fecha') || '';
      var horasFijas = parseInt(reloj.getAttribute('data-pa-horas-fijas'), 10) || 24;
      var utc = parseFloat(reloj.getAttribute('data-pa-utc'));
      if (isNaN(utc)) utc = -5;

      var bloqueDias = elDias ? elDias.parentNode : null;
      var arranqueCiclo = Date.now();

      function ahoraZona() {
        var local = new Date();
        var utcMs = local.getTime() + local.getTimezoneOffset() * 60000;
        return new Date(utcMs + utc * 3600000);
      }

      function objetivoDiario() {
        var ahora = ahoraZona();
        return new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), 23, 59, 59).getTime();
      }

      function calcularRestante() {
        if (modo === 'fecha' && fechaTexto) {
          var partes = fechaTexto.split('-');
          var objetivo;
          if (partes.length === 3) {
            objetivo = new Date(parseInt(partes[0], 10), parseInt(partes[1], 10) - 1, parseInt(partes[2], 10), 23, 59, 59).getTime();
          } else {
            objetivo = new Date(fechaTexto).getTime();
          }
          var ahoraF = ahoraZona().getTime();
          return Math.floor((objetivo - ahoraF) / 1000);
        }
        if (modo === 'ciclo') {
          var transcurrido = Math.floor((Date.now() - arranqueCiclo) / 1000);
          var total = horasFijas * 3600;
          var restanteC = total - (transcurrido % total);
          return restanteC;
        }
        var ahoraD = ahoraZona().getTime();
        return Math.floor((objetivoDiario() - ahoraD) / 1000);
      }

      function pintar() {
        var restante = calcularRestante();
        if (restante < 0) restante = 0;

        var d = Math.floor(restante / 86400);
        var h = Math.floor((restante % 86400) / 3600);
        var m = Math.floor((restante % 3600) / 60);
        var s = restante % 60;

        if (bloqueDias) {
          if (d > 0 && modo === 'fecha') {
            bloqueDias.classList.remove('pa-countdown-oculto');
            if (elDias) elDias.textContent = dosDigitos(d);
          } else {
            bloqueDias.classList.add('pa-countdown-oculto');
          }
        }
        if (modo !== 'fecha') {
          h = Math.floor(restante / 3600);
        }

        if (elHoras) elHoras.textContent = dosDigitos(h);
        if (elMin) elMin.textContent = dosDigitos(m);
        if (elSeg) elSeg.textContent = dosDigitos(s);
      }

      pintar();
      setInterval(pintar, 1000);
    }

    function iniciarCopia(boton) {
      if (boton.dataset.paIniciado === '1') return;
      boton.dataset.paIniciado = '1';

      boton.addEventListener('click', function (e) {
        var codigo = boton.getAttribute('data-pa-codigo') || '';
        function mostrar() {
          boton.classList.add('pa-countdown-activo');
          setTimeout(function () { boton.classList.remove('pa-countdown-activo'); }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(mostrar).catch(mostrar);
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = codigo;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(tmp);
          mostrar();
        }
      });
    }

    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var relojes = raiz.querySelectorAll('[data-pa-countdown]');
      for (var i = 0; i < relojes.length; i++) iniciar(relojes[i]);
      var botones = raiz.querySelectorAll('[data-pa-copiar]');
      for (var j = 0; j < botones.length; j++) iniciarCopia(botones[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }

    document.addEventListener('shopify:section:load', function (e) { arrancar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(seccion) {
      if (seccion.dataset.paHsInit === 'true') return;
      seccion.dataset.paHsInit = 'true';

      var puntos = seccion.querySelectorAll('[data-pa-hs-punto]');
      if (!puntos.length) return;

      function cerrarTodos(excepto) {
        Array.prototype.forEach.call(puntos, function (p) {
          if (p !== excepto) p.classList.remove('pa-hs-abierto');
        });
      }

      Array.prototype.forEach.call(puntos, function (punto) {
        var boton = punto.querySelector('[data-pa-hs-boton]');
        if (!boton) return;

        boton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var abierto = punto.classList.contains('pa-hs-abierto');
          cerrarTodos(punto);
          if (abierto) {
            punto.classList.remove('pa-hs-abierto');
          } else {
            punto.classList.add('pa-hs-abierto');
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!seccion.contains(e.target)) cerrarTodos(null);
      });
    }

    function iniciarTodas() {
      document.querySelectorAll('.pa-seccion-hotspots').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('.pa-seccion-hotspots');
      if (seccion) {
        seccion.dataset.paHsInit = 'false';
        iniciar(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-producto-detalle"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var secciones = document.querySelectorAll('.pa-seccion-hotspots');
      secciones.forEach(function (sec) {
        var puntos = sec.querySelectorAll('[data-pa-hs-punto]');
        var conts = sec.querySelectorAll('.pa-hs-punto-cont');
        function cerrarTodo() {
          conts.forEach(function (c) { c.classList.remove('pa-hs-activo'); });
        }
        puntos.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var cont = btn.closest('.pa-hs-punto-cont');
            var abierto = cont.classList.contains('pa-hs-activo');
            cerrarTodo();
            if (!abierto) { cont.classList.add('pa-hs-activo'); }
          });
        });
        sec.querySelectorAll('[data-pa-hs-cerrar]').forEach(function (x) {
          x.addEventListener('click', function (e) {
            e.stopPropagation();
            var cont = x.closest('.pa-hs-punto-cont');
            if (cont) { cont.classList.remove('pa-hs-activo'); }
          });
        });
        document.addEventListener('click', function (e) {
          if (!e.target.closest('.pa-hs-punto-cont')) { cerrarTodo(); }
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-resenas-google"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(marquesina) {
      if (marquesina.dataset.paIniciado === '1') return;
      marquesina.dataset.paIniciado = '1';

      var pista = marquesina.querySelector('.pa-resgoogle-pista');
      if (!pista) return;

      var auto = marquesina.getAttribute('data-pa-auto') === '1';
      var originales = Array.prototype.slice.call(pista.children);
      if (!auto || originales.length === 0) {
        pista.style.animation = 'none';
        pista.style.width = 'auto';
        marquesina.style.overflowX = 'auto';
        return;
      }

      originales.forEach(function (nodo) {
        var clon = nodo.cloneNode(true);
        clon.setAttribute('aria-hidden', 'true');
        pista.appendChild(clon);
      });

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        pista.style.animation = 'none';
      }
    }

    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var lista = raiz.querySelectorAll('[data-pa-resgoogle]');
      for (var i = 0; i < lista.length; i++) iniciar(lista[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }

    document.addEventListener('shopify:section:load', function (e) { arrancar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-resenas-lista"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(seccion) {
      if (seccion.dataset.paRlInit === 'true') return;
      seccion.dataset.paRlInit = 'true';

      var boton = seccion.querySelector('[data-pa-rl-boton]');
      if (!boton) return;

      var cantidad = parseInt(boton.getAttribute('data-pa-rl-cantidad'), 10) || 5;

      boton.addEventListener('click', function () {
        var ocultas = seccion.querySelectorAll('[data-pa-rl-oculta]');
        var mostradas = 0;

        Array.prototype.forEach.call(ocultas, function (item) {
          if (mostradas < cantidad) {
            item.classList.remove('pa-rl-oculta');
            item.removeAttribute('data-pa-rl-oculta');
            mostradas++;
          }
        });

        if (!seccion.querySelectorAll('[data-pa-rl-oculta]').length) {
          boton.parentNode.style.display = 'none';
        }
      });
    }

    function iniciarTodas() {
      document.querySelectorAll('.pa-seccion-rl').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('.pa-seccion-rl');
      if (seccion) {
        seccion.dataset.paRlInit = 'false';
        iniciar(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-resenas-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(seccion) {
      if (seccion.dataset.paRtInit === 'true') return;
      seccion.dataset.paRtInit = 'true';

      var carrusel = seccion.querySelector('[data-pa-rt-carrusel]');
      if (!carrusel) return;

      var autoplay = seccion.getAttribute('data-pa-rt-autoplay') === 'true';
      var velocidad = parseFloat(seccion.getAttribute('data-pa-rt-velocidad')) || 4;
      var intervalo = null;
      var pausado = false;
      var reanudar = null;

      function paso() {
        var tarjeta = carrusel.querySelector('.pa-rt-tarjeta');
        if (!tarjeta) return 300;
        var estilo = getComputedStyle(carrusel);
        var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
        return tarjeta.offsetWidth + gap;
      }

      function avanzar() {
        var fin = carrusel.scrollWidth - carrusel.clientWidth - 6;
        if (carrusel.scrollLeft >= fin) {
          carrusel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          carrusel.scrollBy({ left: paso(), behavior: 'smooth' });
        }
      }

      function arrancarAuto() {
        if (!autoplay || intervalo) return;
        intervalo = setInterval(function () {
          if (!pausado) avanzar();
        }, velocidad * 1000);
      }

      function pausar() {
        pausado = true;
        if (reanudar) clearTimeout(reanudar);
        reanudar = setTimeout(function () {
          pausado = false;
        }, velocidad * 1500);
      }

      carrusel.addEventListener('touchstart', pausar, { passive: true });
      carrusel.addEventListener('mousedown', pausar);
      seccion.addEventListener('mouseenter', function () {
        pausado = true;
      });
      seccion.addEventListener('mouseleave', function () {
        pausado = false;
      });

      arrancarAuto();
    }

    function iniciarTodas() {
      document.querySelectorAll('.pa-seccion-resenas').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('.pa-seccion-resenas');
      if (seccion) {
        seccion.dataset.paRtInit = 'false';
        iniciar(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-resenas-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(grid) {
      if (grid.dataset.paIniciado === '1') return;
      grid.dataset.paIniciado = '1';

      var plays = grid.querySelectorAll('[data-pa-play]');
      for (var i = 0; i < plays.length; i++) {
        (function (boton) {
          boton.addEventListener('click', function () {
            var media = boton.closest('[data-pa-media]');
            var video = media ? media.querySelector('[data-pa-video]') : null;
            if (!video) return;
            video.muted = false;
            video.controls = true;
            media.classList.add('pa-resvid-reproduciendo');
            var p = video.play();
            if (p && p.catch) { p.catch(function () {}); }
          });
        })(plays[i]);
      }
    }

    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var lista = raiz.querySelectorAll('[data-pa-resvid]');
      for (var i = 0; i < lista.length; i++) iniciar(lista[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }
    document.addEventListener('shopify:section:load', function (e) { arrancar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-resenas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(carrusel) {
      if (carrusel.dataset.paIniciado === '1') return;
      carrusel.dataset.paIniciado = '1';

      var pista = carrusel.querySelector('.pa-resenas-pista');
      if (!pista) return;

      var originales = Array.prototype.slice.call(pista.children);
      if (originales.length === 0) return;

      var auto = carrusel.getAttribute('data-pa-auto') === '1';
      var velocidad = parseInt(carrusel.getAttribute('data-pa-velocidad'), 10) || 3500;

      if (originales.length < 2 || !auto) {
        return;
      }

      originales.forEach(function (nodo) {
        var clon = nodo.cloneNode(true);
        clon.setAttribute('aria-hidden', 'true');
        pista.appendChild(clon);
      });

      var indice = 0;
      var timer = null;

      function visibles() {
        var ancho = window.innerWidth;
        if (ancho >= 990) return 3;
        if (ancho >= 749) return 2;
        return 1;
      }

      function pasoAncho() {
        var primera = pista.children[0];
        if (!primera) return 0;
        var estilo = getComputedStyle(pista);
        var gap = parseFloat(estilo.columnGap || estilo.gap || '0') || 0;
        return primera.getBoundingClientRect().width + gap;
      }

      function avanzar() {
        indice++;
        pista.style.transition = 'transform 0.6s ease';
        pista.style.transform = 'translateX(' + (-pasoAncho() * indice) + 'px)';
      }

      pista.addEventListener('transitionend', function () {
        if (indice >= originales.length) {
          pista.style.transition = 'none';
          indice = 0;
          pista.style.transform = 'translateX(0px)';
          void pista.offsetWidth;
        }
      });

      function arrancarTimer() {
        detener();
        timer = setInterval(avanzar, velocidad);
      }

      function detener() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      carrusel.addEventListener('mouseenter', detener);
      carrusel.addEventListener('mouseleave', arrancarTimer);

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) arrancarTimer();

      window.addEventListener('resize', function () {
        pista.style.transition = 'none';
        pista.style.transform = 'translateX(' + (-pasoAncho() * indice) + 'px)';
      });
    }

    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var lista = raiz.querySelectorAll('[data-pa-resenas]');
      for (var i = 0; i < lista.length; i++) iniciar(lista[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }

    document.addEventListener('shopify:section:load', function (e) { arrancar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-resultados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(seccion) {
      if (seccion.dataset.paRsInit === 'true') return;
      seccion.dataset.paRsInit = 'true';

      var animar = seccion.getAttribute('data-pa-rs-animar') === 'true';
      var duracion = parseFloat(seccion.getAttribute('data-pa-rs-duracion')) || 1.4;
      var anillos = seccion.querySelectorAll('[data-pa-rs-anillo]');
      if (!anillos.length) return;

      Array.prototype.forEach.call(anillos, function (anillo) {
        var circulo = anillo.querySelector('[data-pa-rs-offset]');
        var numero = anillo.querySelector('[data-pa-rs-num]');
        if (circulo) {
          circulo.style.transitionDuration = duracion + 's';
          if (animar) circulo.style.strokeDashoffset = '100';
        }
        if (numero && animar) numero.textContent = '0';
      });

      function correr(anillo) {
        if (anillo.dataset.paRsHecho === 'true') return;
        anillo.dataset.paRsHecho = 'true';

        var circulo = anillo.querySelector('[data-pa-rs-offset]');
        var numero = anillo.querySelector('[data-pa-rs-num]');
        var offset = parseFloat(circulo ? circulo.getAttribute('data-pa-rs-offset') : 0) || 0;
        var final = parseInt(numero ? numero.getAttribute('data-pa-rs-final') : 0, 10) || 0;

        if (circulo) circulo.style.strokeDashoffset = offset;
        if (!numero) return;

        var inicio = null;
        var ms = duracion * 1000;

        function paso(t) {
          if (!inicio) inicio = t;
          var avance = Math.min((t - inicio) / ms, 1);
          var suave = 1 - Math.pow(1 - avance, 3);
          numero.textContent = Math.round(final * suave);
          if (avance < 1) requestAnimationFrame(paso);
        }

        requestAnimationFrame(paso);
      }

      if (!animar || !('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(anillos, correr);
        return;
      }

      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              correr(entrada.target);
              observador.unobserve(entrada.target);
            }
          });
        },
        { threshold: 0.4 }
      );

      Array.prototype.forEach.call(anillos, function (anillo) {
        observador.observe(anillo);
      });
    }

    function iniciarTodas() {
      document.querySelectorAll('.pa-seccion-resultados').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('.pa-seccion-resultados');
      if (seccion) {
        seccion.dataset.paRsInit = 'false';
        var anillos = seccion.querySelectorAll('[data-pa-rs-anillo]');
        Array.prototype.forEach.call(anillos, function (a) {
          a.dataset.paRsHecho = 'false';
        });
        iniciar(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-split-flap"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ALFABETO = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789%-./:!?$&+';

    function crearCelda(velocidad) {
      var celda = document.createElement('div');
      celda.className = 'pa-splitflap-celda';

      var arriba = document.createElement('div');
      arriba.className = 'pa-splitflap-panel pa-splitflap-arriba';
      var arribaSpan = document.createElement('span');
      arriba.appendChild(arribaSpan);

      var abajo = document.createElement('div');
      abajo.className = 'pa-splitflap-panel pa-splitflap-abajo';
      var abajoSpan = document.createElement('span');
      abajo.appendChild(abajoSpan);

      var flip = document.createElement('div');
      flip.className = 'pa-splitflap-panel pa-splitflap-flip';
      var flipSpan = document.createElement('span');
      flip.appendChild(flipSpan);

      celda.appendChild(arriba);
      celda.appendChild(abajo);
      celda.appendChild(flip);

      var actual = ' ';
      arribaSpan.textContent = actual;
      abajoSpan.textContent = actual;
      flipSpan.textContent = actual;

      function paso(siguiente) {
        return new Promise(function (resolve) {
          flipSpan.textContent = actual;
          arribaSpan.textContent = siguiente;
          celda.classList.remove('pa-girando');
          void celda.offsetWidth;
          celda.classList.add('pa-girando');
          var terminado = false;
          function fin() {
            if (terminado) return;
            terminado = true;
            celda.classList.remove('pa-girando');
            actual = siguiente;
            abajoSpan.textContent = siguiente;
            flipSpan.textContent = siguiente;
            resolve();
          }
          flip.addEventListener('animationend', fin, { once: true });
          setTimeout(fin, velocidad + 80);
        });
      }

      celda.irHacia = function (objetivo) {
        objetivo = (objetivo || ' ').toUpperCase();
        if (ALFABETO.indexOf(objetivo) === -1) objetivo = ' ';
        var idx = ALFABETO.indexOf(actual);
        if (idx === -1) idx = 0;
        var destino = ALFABETO.indexOf(objetivo);
        var pasos = [];
        var guard = 0;
        while (idx !== destino && guard < ALFABETO.length + 1) {
          idx = (idx + 1) % ALFABETO.length;
          pasos.push(ALFABETO[idx]);
          guard++;
        }
        var cadena = Promise.resolve();
        pasos.forEach(function (c) {
          cadena = cadena.then(function () { return paso(c); });
        });
        return cadena;
      };

      return celda;
    }

    function iniciar(tablero) {
      if (tablero.dataset.paIniciado === '1') return;
      tablero.dataset.paIniciado = '1';

      var nodo = tablero.parentNode.querySelector('[data-pa-mensajes]');
      var mensajes = [];
      if (nodo) {
        try {
          mensajes = JSON.parse(nodo.textContent) || [];
        } catch (e) {
          mensajes = [];
        }
      }
      mensajes = mensajes.map(function (m) { return (m == null ? '' : String(m)).trim(); }).filter(function (m) { return m.length; });
      if (!mensajes.length) mensajes = ['SALE'];

      var minCeldas = parseInt(tablero.getAttribute('data-pa-celdas'), 10) || 4;
      var maxLargo = mensajes.reduce(function (a, m) { return Math.max(a, m.length); }, minCeldas);

      var seccion = tablero.closest('.pa-seccion-splitflap');
      var estilo = getComputedStyle(seccion);
      var velocidad = parseInt(estilo.getPropertyValue('--pa-splitflap-velocidad'), 10) || 220;
      var pausa = parseInt(estilo.getPropertyValue('--pa-splitflap-pausa'), 10) || 2200;

      tablero.innerHTML = '';
      var celdas = [];
      for (var i = 0; i < maxLargo; i++) {
        var celda = crearCelda(velocidad);
        tablero.appendChild(celda);
        celdas.push(celda);
      }

      function centrar(texto) {
        var libre = maxLargo - texto.length;
        var izq = Math.floor(libre / 2);
        var salida = '';
        for (var i = 0; i < izq; i++) salida += ' ';
        salida += texto;
        while (salida.length < maxLargo) salida += ' ';
        return salida;
      }

      function mostrar(texto) {
        var t = centrar(texto.toUpperCase());
        var promesas = [];
        for (var i = 0; i < celdas.length; i++) {
          promesas.push(celdas[i].irHacia(t[i] || ' '));
        }
        return Promise.all(promesas);
      }

      var indice = 0;

      if (mensajes.length === 1) {
        mostrar(mensajes[0]);
        return;
      }

      function ciclo() {
        mostrar(mensajes[indice]).then(function () {
          indice = (indice + 1) % mensajes.length;
          setTimeout(ciclo, pausa);
        });
      }

      ciclo();
    }

    function arrancar(scope) {
      var raiz = scope && scope.querySelectorAll ? scope : document;
      var tableros = raiz.querySelectorAll('[data-pa-splitflap]');
      for (var i = 0; i < tableros.length; i++) {
        iniciar(tableros[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
    } else {
      arrancar(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      arrancar(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-tabla-precios"] && !Shopify.designMode) return;
  try {
    
  class PaTablaPrecios extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const botones = this.querySelectorAll('.pa-tp-boton');
      botones.forEach((boton) => {
        boton.addEventListener('click', (e) => {
          e.preventDefault();
          this.comprar(boton);
        });
      });
    }

    comprar(boton) {
      const sectionId = boton.getAttribute('data-pa-tp-section');
      const cantidad = parseInt(boton.getAttribute('data-pa-tp-cantidad'), 10) || 1;

      const inputCantidad = document.querySelector('#Quantity-' + sectionId);
      if (inputCantidad) {
        inputCantidad.value = cantidad;
        inputCantidad.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const botonCompra =
        document.querySelector('.main-product-atc[name="add"]') ||
        document.querySelector('.main-product-atc');

      if (botonCompra) {
        botonCompra.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          botonCompra.click();
        }, 250);
      }
    }
  }

  if (!customElements.get('pa-tabla-precios')) {
    customElements.define('pa-tabla-precios', PaTablaPrecios);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.pa-seccion-tabla-precios').forEach((el) => {
      if (el.tagName.toLowerCase() !== 'pa-tabla-precios' && !el.dataset.paInit) {
        el.dataset.paInit = 'true';
        const botones = el.querySelectorAll('.pa-tp-boton');
        botones.forEach((boton) => {
          boton.addEventListener('click', (e) => {
            e.preventDefault();
            const sectionId = boton.getAttribute('data-pa-tp-section');
            const cantidad = parseInt(boton.getAttribute('data-pa-tp-cantidad'), 10) || 1;
            const inputCantidad = document.querySelector('#Quantity-' + sectionId);
            if (inputCantidad) {
              inputCantidad.value = cantidad;
              inputCantidad.dispatchEvent(new Event('change', { bubbles: true }));
            }
            const botonCompra =
              document.querySelector('.main-product-atc[name="add"]') ||
              document.querySelector('.main-product-atc');
            if (botonCompra) {
              botonCompra.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setTimeout(() => {
                botonCompra.click();
              }, 250);
            }
          });
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-testimonios-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarSeccion(seccion) {
      if (seccion.dataset.paTvInit === 'true') return;
      seccion.dataset.paTvInit = 'true';

      var carrusel = seccion.querySelector('[data-pa-tv-carrusel]');
      var prev = seccion.querySelector('[data-pa-tv-prev]');
      var next = seccion.querySelector('[data-pa-tv-next]');

      function paso() {
        var tarjeta = carrusel ? carrusel.querySelector('.pa-tv-tarjeta') : null;
        if (!tarjeta) return 300;
        var estilo = getComputedStyle(carrusel);
        var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
        return tarjeta.offsetWidth + gap;
      }

      if (prev && carrusel) {
        prev.addEventListener('click', function () {
          carrusel.scrollBy({ left: -paso(), behavior: 'smooth' });
        });
      }

      if (next && carrusel) {
        next.addEventListener('click', function () {
          carrusel.scrollBy({ left: paso(), behavior: 'smooth' });
        });
      }

      var cajas = seccion.querySelectorAll('[data-pa-tv-caja]');
      Array.prototype.forEach.call(cajas, function (caja) {
        var boton = caja.querySelector('[data-pa-tv-play]');
        var video = caja.querySelector('[data-pa-tv-video]');
        if (!boton || !video) return;

        boton.addEventListener('click', function () {
          Array.prototype.forEach.call(cajas, function (otra) {
            if (otra === caja) return;
            var otroVideo = otra.querySelector('[data-pa-tv-video]');
            if (otroVideo && !otroVideo.paused) {
              otroVideo.pause();
              otra.classList.remove('pa-tv-activo');
            }
          });

          caja.classList.add('pa-tv-activo');
          var reproduccion = video.play();
          if (reproduccion && typeof reproduccion.catch === 'function') {
            reproduccion.catch(function () {
              caja.classList.remove('pa-tv-activo');
            });
          }
        });

        video.addEventListener('pause', function () {
          if (video.currentTime === 0 || video.ended) {
            caja.classList.remove('pa-tv-activo');
          }
        });

        video.addEventListener('ended', function () {
          video.currentTime = 0;
          caja.classList.remove('pa-tv-activo');
        });
      });
    }

    function iniciarTodas() {
      document.querySelectorAll('.pa-seccion-testimonios').forEach(iniciarSeccion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target.querySelector('.pa-seccion-testimonios');
      if (seccion) {
        seccion.dataset.paTvInit = 'false';
        iniciarSeccion(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
